import { googleAnalyticsLib } from 'freedom-shared';
import type { Airflow } from '@aviata/platform-types';

import {
  aviaTourPromoOfferShown,
  aviaTourPromoOfferClicked,
} from './avia-tour-promo';
import { mainPageOpen, submitSearchForm } from './main-page';
import { bookingSuccess, bookingError } from './products-page';
import {
  hotOffersScroll,
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersSearchClick,
} from './hot-offers';

const searchPageOpen = () => googleAnalyticsLib.sendEvent('avfree_serp_page');

const detailsPageOpen = () =>
  googleAnalyticsLib.sendEvent('avfree_details_open');
const detailsPageContinue = () =>
  googleAnalyticsLib.sendEvent('avfree_details_continue_click');

const fareFamilyPageOpen = () => googleAnalyticsLib.sendEvent('avfree_ff_open');
const selectFareFamily = (choice: Airflow.FareFamily.Choice) => {
  googleAnalyticsLib.sendEvent('avfree_ff_choose_click', {
    ff_name: choice.code,
    ff_index: choice.id,
  });
};

const openPassengersDataPage = () =>
  googleAnalyticsLib.sendEvent('avfree_pass_page_open');
const submitPassengersData = () =>
  googleAnalyticsLib.sendEvent('avfree_pass_continue_click');

export const googleAnalyticsEventsLib = {
  aviaTourPromoOfferShown,
  aviaTourPromoOfferClicked,
  mainPageOpen,
  submitSearchForm,
  searchPageOpen,
  detailsPageOpen,
  detailsPageContinue,
  fareFamilyPageOpen,
  selectFareFamily,
  openPassengersDataPage,
  submitPassengersData,
  bookingError,
  bookingSuccess,
  hotOffersScroll,
  hotOffersAllDatesClick,
  hotOffersOriginCityChange,
  hotOffersSearchClick,
};
